import React from 'react';
import SkillCategoryPage from '../../components/SkillCategoryPage';

const App = (props) => <SkillCategoryPage {...props} />;

export default App;
